import { render, staticRenderFns } from "./text-editor.vue?vue&type=template&id=5ec8363c&scoped=true&"
import script from "./text-editor.vue?vue&type=script&lang=js&"
export * from "./text-editor.vue?vue&type=script&lang=js&"
import style0 from "./text-editor.vue?vue&type=style&index=0&id=5ec8363c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec8363c",
  null
  
)

export default component.exports